module.exports = __webpack_public_path__ + "img/car_blue.d82f3f00.png";